<template>
  <tr>
    <td>
      <input type="text" v-model="formData.kc" disabled />
    </td>
    <td>
      <input type="text" v-model="formData.no_seal" disabled />
    </td>
    <td>
      <input
        type="text"
        v-model="formData.no_container"
        @keydown.enter="focusRefs('cargo')"
        @blur="updateContainer"
        disabled
        ref="no_container"
      />
    </td>
    <td>
      <input
        type="text"
        v-model="formData.cargo"
        @keydown.enter="focusRefs('bl')"
        @blur="updateContainer"
        ref="cargo"
      />
    </td>
    <td>
      <input
        type="text"
        v-model="formData.bl"
        @keydown.enter="focusRefs('no_bl')"
        @blur="updateContainer"
        ref="bl"
      />
    </td>
    <!-- <td> -->
    <!-- <input type="text" v-model="formData.no_bl" @keydown.enter="focusRefs('no_spk')" @blur="updateContainer" ref="no_bl"> -->
    <!-- </td> -->
    <td>
      <input
        type="text"
        v-model="formData.no_spk"
        @keydown.enter="focusRefs('tgl_spk')"
        @blur="updateContainer"
        ref="no_spk"
      />
    </td>
    <td>
      <input
        type="date"
        v-model="formData.tgl_spk"
        @keydown.enter="updateContainer"
        @blur="updateContainer"
        ref="tgl_spk"
      />
    </td>
  </tr>
</template>

<script>
import axios from "axios";

export default {
  name: "Container",
  props: ["data"],
  data() {
    return {
      formData: {
        kc: "",
        no_container: "",
        cargo: "",
        bl: "",
        no_bl: "",
        no_spk: "",
        tgl_spk: ""
      }
    };
  },
  methods: {
    async updateContainer() {
      const cargo = (this.formData.cargo || "").trim();
      const noContainer = (this.formData.no_container || "").trim();

      if (!cargo && !noContainer) {
        return;
      }

      await axios
        .put(`update-container-data-bl/${this.data.id}`, this.formData)
        .then(res => {
          // console.log(res.data);
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    focusRefs(id) {
      this.$refs[id].focus();
    }
  },
  created() {
    this.formData.kc = this.data.kc;
    this.formData.no_seal = this.data.no_seal;
    this.formData.no_container = this.data.no_container;
    this.formData.cargo = this.data.cargo;
    this.formData.bl = this.data.bl;
    this.formData.no_bl = this.data.no_bl;
    this.formData.no_spk = this.data.no_spk;
    this.formData.tgl_spk = this.data.tgl_spk;
  }
};
</script>

<style scoped>
input[type="text"] {
  outline: none;
  border: 1px solid lightgray;
  padding: 0 0.5em;
  width: 100%;
}
</style>

<style lang="scss" scoped>
tbody {
  tr:hover {
    background-color: transparent !important;
  }
}
</style>
